import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityTrackingService {

  constructor() { }

  private backButtonSubject = new BehaviorSubject<boolean>(false);
  backButton$ = this.backButtonSubject.asObservable();

  backButtonClicked(){
    this.backButtonSubject.next(true);
  }

  resetBackButtonStatus(){
    this.backButtonSubject.next(false);
  }
}
